<template>
	<div class="myMapBox">
		<div @click="getData" class="titleBox disBetween">
			<div class="projectName">安驿生活综合管理平台
			</div>

			<div class="timeBox" v-html="timeData"></div>
			<div class="NewBox ">

				<span class="warnIcon">
					<span></span>
				</span>
				<span class="warnNum">{{warnNum}}</span>
			</div>
		</div>

		<div id="container"></div>
		<div class="leftBox">
			<leftPart ref="leftPart"></leftPart>
		</div>
		<div class="rightBox">
			<div class="tabBox">
				<div class="tabItem disCenter" :class="{active:active==0}" @click="active=0">设备情况</div>
				<div class="tabItem disCenter" :class="{active:active==1}" @click="active=1">营收情况</div>
			</div>
			<rightPart ref="rightPart" v-if="active==0"></rightPart>
			<rightPartOther ref="rightPartOther" v-if="active==1"></rightPartOther>
		</div>
	</div>
</template>

<script type="text/javascript">
	import AMapLoader from "@amap/amap-jsapi-loader"
	import leftPart from "../leftPart/leftPart.vue"
	import rightPart from "../rightPart/rightPart.vue"
	import rightPartOther from "../rightPart/rightPartOther.vue"
	import {
		getTime,
		temData
	} from "../../assets/js/common.js"
	window._AMapSecurityConfig = {
		// securityJsCode: 'fbfe9ed39101632111f069d76bf27a88',//测试环境
		securityJsCode: '92759b91f4a3029c8c63614b87eebedc' //正式环境 
	}
	var textStyle = {
		fontSize: 12,
		fontWeight: 'normal',
		fillColor: '#fff',
		// fillColor: 'rgb(255, 215, 0)',
		// strokeColor: '#fff',
		// strokeWidth: 2,
		// fold: true,
		padding: '2, 5',
		backgroundColor: 'rgb(246,137,38)',
		borderColor: '#fff',
		borderWidth: 1,
	}
	export default {
		name: 'myMap',
		props: {
			msg: String
		},
		components: {
			leftPart,
			rightPart,
			rightPartOther
		},
		data() {
			return {
				ddddList: [{}],
				active: 0,
				warnNum: 0,
				timeData: "",
				map: null,
				marker: null,
				maker: null,
				gridSize: 120, // 设置网格像素大小
				marker: [118.803129, 32.065761],
				icon: null,
				mapModule: null, // AMap
				center: [118.803129, 32.065761],
				zoom: 10, //初始化地图级别
				cluster: null, // 点聚合
				points: [ // 这个数据是小编随便捏的，具体看后端怎么给你值

				],
				selectItem: {}, //选中数据
				timer: null
			}
		},
		created() {
			// this.$set(this, "points", temData)
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		mounted() {
			if (this.timer) {
				this.timer = null
				clearInterval(this.timer);
			}
			this.timer = null
			let that = this
			this.$nextTick(() => {
				// this.initMap()
				this.listCommunitySiteByCommunityId()
				setInterval(() => {
					that.$set(that, "timeData", getTime())
				}, 1000)
				this.timer = setInterval(() => {
					that.$refs.leftPart.getdata()
					if (that.active == 0) {
						that.$refs.rightPart.getdata()
					} else {
						that.$refs.rightPartOther.getdata()
					}
				}, 300000)
			})

		},
		methods: {
			test() {
				this.$api.login({
					loginName: 'admin',
					loginPassword: '123456'
				}).then(res => {
					console.log(res)
					localStorage.setItem('token', res.obj)
				}).catch(function(error) {
					console.log(error);
				});
			},

			listCommunitySiteByCommunityId() {
				this.$api.listCommunitySiteByCommunityId({

				}).then(res => {
					// console.log(res)
					this.points = []
					res.obj.forEach((item) => {
						let obj = {
							num: item.communityEquipmentNumber,
							lnglat: [item.communitySiteLongitude, item.communitySiteLatitude],
							communitySiteId: item.communitySiteId
						}
						this.points.push(obj)

					})
					// console.log(this.points)
					this.initMap()

				}).catch(function(error) {
					console.log(error);
				});
			},
			listCommunityEquipmentBySelective(item, obj) {


				let that = this
				this.$api.listCommunityEquipmentBySelective({
					communitySiteId: obj.communitySiteId
				}).then(res => {
					console.log(res)



					var content = '这是信息窗体！'
					const infoWindow = new AMap.InfoWindow({
						content: that.getContent(res.obj), // 使用默认信息窗体框样式，显示信息内容
						offset: new AMap.Pixel(0, -40),
						closeWhenClickMap: true,
						autoMove: true
					})
					infoWindow.on("mouseover", function() {
						that.map.setStatus({
							scrollWheel: false
						});
					});
					infoWindow.on("mouseout", () => {
						that.map.setStatus({
							scrollWheel: true
						});
					});
					infoWindow.open(this.map, item.lnglat);



				}).catch(function(error) {
					console.log(error);
				});
			},

			initMap() {
				let that = this;
				AMapLoader.load({
					key: 'f0973413d1838d34702c84208aa119fc', //正式环境 
					// key: '2d6486ec1e527d7e0597a7e73089a11b',//测试环境
					version: '2.0',
					plugins: ['AMap.AutoComplete', 'AMap.PlaceSearch', 'AMap.MarkerClusterer',
						'AMap.DistrictSearch', 'AMap.MouseTool'
					], //需要使用的的插件列表，如比例尺'AMap.Scale'等
				}).then(AMap => {
					that.mapModule = AMap;
					that.map = new AMap.Map('container', {
						resizeEnable: true,
						center: that.center, //默认南京市政府
						zoom: that.zoom, //初始化地图级别
						mapStyle: "amap://styles/5ee498e123227e8bb6a9b44ef93e7c0e"
					})

					that.cluster = new AMap.MarkerCluster(that.map, that.points, {
						renderClusterMarker: that.renderClusterMarker, // 自定义聚合点样式
						gridSize: that.gridSize, // 设置网格像素大小
						renderMarker: that.renderMarker, // 自定义非聚合点样式
					});
				})
			},
			// 聚合点样式
			renderClusterMarker(context) {
				let that = this;
				let count = that.points.length;
				let div = document.createElement('div');
				div.style.backgroundColor = 'rgba(255,165,53,1)'; //bgColor
				let size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
				div.style.width = div.style.height = size + 'px';
				div.style.border = 'solid 1px rgba(255,165,53,0.6)';
				div.style.borderRadius = size / 2 + 'px';
				div.style.boxShadow = '0 0 10px 4px ' + 'rgba(255,165,53,1)';
				div.innerHTML = context.count;
				div.style.lineHeight = size + 'px';
				div.style.color = "#fff";
				div.style.fontSize = '22px';
				div.style.textAlign = 'center';
				context.marker.setOffset(new that.mapModule.Pixel(-size / 2, -size / 2));
				context.marker.setContent(div)

				// 自定义点击事件，这边做的是点击聚合点，以聚合点中心，放大一级
				context.marker.on('click', function(e) {
					console.log(e)
					let curZoom = that.map.getZoom();
					if (curZoom < 20) {
						curZoom += 1;
					}
					that.map.setZoomAndCenter(curZoom, e.lnglat);
				});
			},
			// 自定义非聚合点样式
			renderMarker(context) {
				console.log(context)
				let img = require("../../assets/img/zzz.png")
				let content =
					'<div style="height: 40px;letter-spacing: 2px;padding: 0px 10px 0px 0;lin;border:1px solid #c8c3c3;background:rgba(255, 165, 53, 0.4);border-radius: 50px;font-size: 20px;color: #fff;line-height: 45px;display: flex;"><img src="' +
					img + '" style="width: 42px;height: 42px;margin: -1px 10px 0 -3px;"><span style="display:flex">' + (
						context
						.data[0].num || 0) + '<span style="font-size: 12px;">个</span></span></div>';
				let offset = new this.mapModule.Pixel(-9, -9);
				context.marker.setContent(content)
				context.marker.setOffset(offset)
				context.marker.on('click', (cluster, lnglat, target, markers) => {
					console.log(markers)
					this.setInfoWindow(cluster, context)
					// 
				})
			},
			// 自定义弹窗
			setInfoWindow(item, obj) {
				console.log(obj)
				this.listCommunityEquipmentBySelective(item, obj.data[0])
				// if(obj.data[0].equipment && obj.data[0].equipment.length>0){

				// }

			},
			//处理自定义弹窗窗体内容
			getContent(arr) {
				console.log(arr)
				// console.log(obj.data[0].equipment)
				let cenStr = ''
				// let arr = obj.data[0].equipment
				for (let k of arr) {
					let statusName = '正常'
					if (k.equipmentStatus == 1) {
						statusName = '正常'
					} else if (k.equipmentStatus == 2) {
						statusName = '故障'
					} else if (k.equipmentStatus == 3) {
						statusName = '掉线'
					}
					cenStr += `<li>
							<div class="disBetween listItem">
								<span>设备编号:${k.communityEquipmentNo}</span>
								<span class="status0">${statusName}</span>
							</div>
							<div class="disBetween listItem">
								<span>插座规格:${k.equipmentJackNumber}路</span>
								<span>本月服务次数:${k.serviceNumber}次</span>
							</div>
							<div class="disBetween listItem">
							<span>本月用电量:${k.electricityConsumption}kWh</span>
								<span>本月最高负荷:${k.maxLoad}kWh</span>
							</div>
						</li>`
				}
				var content =
					'<div class="diaShow subFont"><div class="diaTop disBetween"><div class="diatitle">充电桩设备信息</div><div class="close"></div></div><div class="diaBot"><ul class="listBox ">' +
					cenStr + '</ul></div></div>'
				return content
			},
			getData() {

			},
		}
	}
</script>

<style lang="scss" scoped>
	.myMapBox {
		width: 100%;
		height: 100%;
		position: relative;

		.titleBox {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 9;
			width: 100%;
			height: 110px;
			background: url('../../assets/img/title.png')no-repeat center;
			background-size: cover;
			padding: 0 60px;
			box-sizing: border-box;
			align-items: flex-start !important;

			.projectName {
				font-size: 48px;
				letter-spacing: 8px;
				font-weight: 600;
				color: #fff;
				line-height: 110px;
				width: 60%;
				text-align: left;
			}

			.timeBox {
				width: 35%;
				height: 70px;
				color: #3dc6cc;
				font-size: 22px;
				line-height: 80px;

				span {
					margin-left: 20px;
				}
			}

			.NewBox {
				width: 5%;
				color: #f49f0c;
				height: 70px;
				font-size: 30px;
				line-height: 70px;
				display: flex;
				align-items: center;
				justify-content: flex-start;

				.warnIcon {
					display: block;
					width: 35px;
					height: 35px;
					background: url('../../assets/img/warning.png')no-repeat center;
					background-size: cover;
					margin-right: 10px;
				}
			}
		}

		#container {
			position: absolute;
			bottom: 0;
			left: 0;
			z-index: 8;
			width: 100%;
			height: 1013px;
		}

		.leftBox {
			position: absolute;
			bottom: 0;
			left: 0;
			z-index: 9;
			height: 970px;
			width: 425px;
			// box-shadow: inset 0px 0px 50px 0px #dce9f3;
			// opacity: 0.9;
			background: url('../../assets/img/leftPart.png')no-repeat center;
			background-size: cover;
		}

		.rightBox {
			position: absolute;
			bottom: 0;
			right: 0;
			z-index: 10;
			height: 1012px;
			width: 450px;
			background: url('../../assets/img/rightPart.png')no-repeat center;
			background-size: cover;

			.tabBox {
				position: absolute;
				width: 50px;
				height: 300px;
				left: -50px;
				top: 40px;
				border-radius: 10px 0 0 10px;
				overflow: hidden;

				.tabItem {
					height: 50%;
					width: 100%;
					writing-mode: vertical-rl;
					font-size: 20px;
					color: #fff;
					font-weight: 600;
					letter-spacing: 6px;
					background: url('../../assets/img/tabAct.png')no-repeat center;
					background-size: 150%;
					cursor: pointer;
					user-select: none;
				}

				.active {
					background: url('../../assets/img/tab.png')no-repeat center;
					background-size: 150%;
				}
			}
		}
	}
</style>